export const iconFontAwesomeShoppingCcApplePay = (
	<i className="fa-solid fa-cc-apple-pay"></i>
);
